import React from "react";
import { ICON_PATHS } from "./paths";

/**
 * Shared line-icon component (PRD_Iconography C1).
 *
 * Renders a single monochrome Lucide-style stroke SVG from the in-repo registry
 * (paths.js) — no icon-library dependency (M1). Icons inherit `currentColor`; set
 * the color on the parent/chip, never hardcode a hex here (C3).
 *
 * A11y (C5): decorative by default (`aria-hidden`); pass `aria-label` for an
 * icon-only interactive element to expose an accessible name.
 */
export default function Icon({
  name,
  size = 20,
  strokeWidth = 1.75,
  className,
  "aria-label": ariaLabel,
  ...rest
}) {
  const paths = ICON_PATHS[name];

  if (!paths) {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn(`<Icon>: unknown name "${name}"`);
    }
    return null;
  }

  const a11y = ariaLabel
    ? { role: "img", "aria-label": ariaLabel }
    : { "aria-hidden": "true" };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...a11y}
      {...rest}
    >
      {paths}
    </svg>
  );
}
